import React from 'react'
import About from './About'

const Package = () => {
  return (
<About />
)
}

export default Package